import { Button, HStack } from '@chakra-ui/react';
import React, { FC } from 'react';
import { NftMarketplaceStakeDialog } from '@app/screens/nft-marketplace/NFTMarketplaceStakeDialog';
import { useToggle } from 'react-use';

export const StakeButton: FC = () => {
  const [showStake, toggleStake] = useToggle(false);

  return (
    <>
      <NftMarketplaceStakeDialog
        isOpen={showStake}
        onClose={() => toggleStake(false)}
      />
      <Button
        backgroundColor="orange"
        borderRadius="8px"
        padding="8px 14px"
        alignItems="center"
        width={['100%', '100px']}
        fontWeight="500"
        size="16px"
        lineHeight="26px"
        justifyContent="center"
        color="white"
        gap="4px"
        _hover={{ filter: 'brightness(120%)' }}
        onClick={() => toggleStake(true)}
      >
        Stake
      </Button>
    </>
  );
};
